import 'whatwg-fetch';
import EventEmitter from 'eventemitter3';
import { build } from './entity';
import { events } from './events';
class ResponseError extends Error {
    constructor(message, response) {
        super(message);
        this.response = response;
    }
}
// サーバとのやりとり
export class Repository {
    constructor({ endpoint }) {
        this.endpoint = endpoint;
        this.ee = new EventEmitter();
    }
    getRequest(url) {
        return fetch(url, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    postRequest(url, body, method = 'POST') {
        return fetch(url, {
            method,
            body: body ? JSON.stringify(body) : null,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': this.csrfToken,
            },
        });
    }
    index() {
        this.emit(events.LOAD_START);
        return this.getRequest(this.endpoint)
            .then(response => {
            this.emit(events.LOAD_END);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                throw new ResponseError(response.statusText, response);
            }
        })
            .then(({ data }) => data.map((...args) => build(args[0])));
    }
    create(position, comment) {
        this.emit(events.LOAD_START);
        return this.postRequest(this.endpoint, { bookmark: { position, comment } })
            .then(response => {
            this.emit(events.LOAD_END);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                throw new ResponseError(response.statusText, response);
            }
        })
            .then(({ data }) => build(data));
    }
    update(bookmark, newComment) {
        this.emit(events.LOAD_START);
        return this.postRequest(bookmark.links.update, { bookmark: { comment: newComment } }, 'PATCH')
            .then(response => {
            this.emit(events.LOAD_END);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                throw new ResponseError(response.statusText, response);
            }
        })
            .then(({ data }) => build(data));
    }
    delete(bookmark) {
        this.emit(events.LOAD_START);
        return this.postRequest(bookmark.links.destroy, null, 'DELETE').then(response => {
            this.emit(events.LOAD_END);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            else {
                throw new ResponseError(response.statusText, response);
            }
        });
    }
    emit(event) {
        if (this.ee) {
            this.ee.emit(event);
        }
        return this;
    }
    on(event, listener) {
        if (this.ee) {
            this.ee.on(event, listener);
        }
        return this;
    }
    off(event, listener) {
        if (this.ee) {
            this.ee.off(event, listener);
        }
        return this;
    }
    dispose() {
        this.ee.removeAllListeners();
        this.ee = null;
    }
    get csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        if (meta && meta instanceof HTMLMetaElement) {
            return meta.content;
        }
    }
}
export function createRepository(...args) {
    return new Repository(...args);
}
